import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import {
  PostServiceCaller,
  GetServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa";
import Select from "react-select";

const ObjectTypeEdit = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  useEffect(() => {
    dispatch(updateNavbarHeading("Object Type Edit"));
  }, []);

  const initialFormData = {
    Code: "",
    Name: "",
    Description: "",
    DisplayName: "",
    Group_077: "",
    SubGroup_078: "",
    MenuSequence: "",
    ShowIn_102: "",
    CheckPermissions: "",
    DefaultNarration_071: "",
    DefaultLedgerType_002: "",
    PluginName_081: "",
    ControllerName_082: "",
    ActionName_083: "",
    CopyTaxesFromParent: "",
    CopyAccountsFromParent: "",
    ValidityDays: "",
    IsAdd: "",
    IsEdit: "",
    IsDelete: "",
    RoundOffValue: "",
    RoundOffLevel_035: "",
    RoundOffAccountID: "",
    TradeDiscountAccountID: "",
    TradeDiscountAccountIDAfterTax: "",
  };
  const [formData, setFormData] = useState(initialFormData);
  const [menuList, setMenuList] = useState([]);
  const [headingList, setheadingList] = useState([]);
  const [showINList, setShowINList] = useState([]);
  const [plugINList, setPlugINList] = useState([]);
  const [controllerList, setControllerList] = useState([]);
  const [actionList, setActionList] = useState([]);
  const [accountList, setAccountList] = useState([]);
  const [defaultLedger, setDefaultLedger] = useState([]);
  const [round, setRound] = useState([]);
  const [errors, setErrors] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    if (id) {
      fetchGeneralMaster(id);
    }
    // fetchGeneralMaster();
  }, []);

  // const fetchGeneralMaster = async (id) => {
  //   const response = await GetServiceCaller(`${API_URL}rujul/object-type/${id}`);
  //   if (response.status === 200) {
  //     const fetchData = response?.data?.data;
  //     // Create form data object
  //     const formDataEdit = {
  //       ID: fetchData?.ID,
  //       Code: fetchData?.Code,
  //       Name: fetchData?.Name,
  //       Description: fetchData?.Description,
  //       Group_077: fetchData?.Group_077,
  //       SubGroup_078: fetchData?.SubGroup_078,
  //       DisplayName: fetchData?.DisplayName,
  //       DefaultLedgerType_002: fetchData?.DefaultLedgerType_002,
  //       MenuSequence: fetchData?.MenuSequence,
  //       ShowIn_102: fetchData?.ShowIn_102,
  //       PluginName_081: fetchData?.PluginName_081,
  //       ControllerName_082: fetchData?.ControllerName_082,
  //       ActionName_083: fetchData?.ActionName_083,
  //       ValidityDays: fetchData?.ValidityDays,
  //       IsAdd: fetchData?.IsAdd,
  //       IsEdit: fetchData?.IsEdit,
  //       IsDelete: fetchData?.IsDelete,
  //       CheckPermissions: fetchData?.CheckPermissions,
  //       CopyTaxesFromParent: fetchData?.CopyTaxesFromParent,
  //       CopyAccountsFromParent: fetchData?.CopyAccountsFromParent,
  //       RoundOffValue: fetchData?.RoundOffValue,
  //       RoundOffLevel_035: fetchData?.RoundOffLevel_035,
  //       RoundOffAccountID: fetchData?.RoundOffAccountID,
  //       TradeDiscountAccountID: fetchData?.TradeDiscountAccountID,
  //       TradeDiscountAccountIDAfterTax: fetchData?.TradeDiscountAccountIDAfterTax,
  //     };
  //     setFormData(formDataEdit);
  //     //   setPageLoading(false);
  //   } else {
  //     console.error(
  //       "Failed to fetch model masters. Server responded with status:",
  //       response.status
  //     );
  //   }
  // };
  const fetchGeneralMaster = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}rujul/object-type/${id}`
      );

      if (response.status === 200) {
        const fetchData = response?.data?.data;

        if (!fetchData) {
          console.warn("No data found for the given ID");
          setFormData(null); // Reset form data if no data is found
          return;
        }

        // Create form data object
        const formDataEdit = {
          ID: fetchData?.ID,
          Code: fetchData?.Code,
          Name: fetchData?.Name,
          Description: fetchData?.Description,
          Group_077: fetchData?.Group_077,
          SubGroup_078: fetchData?.SubGroup_078,
          DisplayName: fetchData?.DisplayName,
          DefaultLedgerType_002: fetchData?.DefaultLedgerType_002,
          MenuSequence: fetchData?.MenuSequence,
          ShowIn_102: fetchData?.ShowIn_102,
          PluginName_081: fetchData?.PluginName_081,
          ControllerName_082: fetchData?.ControllerName_082,
          ActionName_083: fetchData?.ActionName_083,
          ValidityDays: fetchData?.ValidityDays,
          IsAdd: fetchData?.IsAdd,
          IsEdit: fetchData?.IsEdit,
          IsDelete: fetchData?.IsDelete,
          CheckPermissions: fetchData?.CheckPermissions,
          CopyTaxesFromParent: fetchData?.CopyTaxesFromParent,
          CopyAccountsFromParent: fetchData?.CopyAccountsFromParent,
          RoundOffValue: fetchData?.RoundOffValue,
          RoundOffLevel_035: fetchData?.RoundOffLevel_035,
          RoundOffAccountID: fetchData?.RoundOffAccountID,
          TradeDiscountAccountID: fetchData?.TradeDiscountAccountID,
          TradeDiscountAccountIDAfterTax:
            fetchData?.TradeDiscountAccountIDAfterTax,
        };

        setFormData(formDataEdit);
      } else {
        console.error(
          "Failed to fetch model masters. Server responded with status:",
          response.status
        );
        setFormData(null); // Reset form data on failure
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setFormData(null);
    }
  };

  const fetchObjTypeData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}rujul/object-type/add-page/details`
      );

      // Menu List Options
      const TnE = response?.data?.data?.menu;
      const menuOpt = TnE.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setMenuList(menuOpt);

      // heading List
      const headOpt = response?.data?.data?.heading;
      const headingOpt = headOpt.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setheadingList(headingOpt);

      // showIN Options
      const showList = response?.data?.data?.showin;
      const showoptlist = showList.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setShowINList(showoptlist);

      // plugin IN List
      const pluginList = response?.data?.data?.plugIn;
      const plugoptlist = pluginList.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setPlugINList(plugoptlist);

      // controller List
      const controlList = response?.data?.data?.controller;
      const controlOptlist = controlList.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setControllerList(controlOptlist);

      // Action List
      const actionOptList = response?.data?.data?.action;
      const actOptlist = actionOptList.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setActionList(actOptlist);

      // Account List
      const accountOptList = response?.data?.data?.accountID;
      const acctOptlist = accountOptList.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setAccountList(acctOptlist);

      // ledger type optin
      const ledgerOptList = response?.data?.data?.defaultLedgerType;
      const defledgerOptlist = ledgerOptList.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setDefaultLedger(defledgerOptlist);
      // RoundOff level list
      const roundOptList = response?.data?.data?.roundOffLevel;
      const rOptlist = roundOptList.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setRound(rOptlist);
      setPageLoading(false);
    } catch (error) {
      console.error("Error fetching TnE:", error);
    }
  };

  useEffect(() => {
    fetchObjTypeData();
  }, []);

  const handleChange = async (e) => {
    const { name, checked, type } = e.target;
    const value = type === "checkbox" ? (checked ? 1 : 0) : e.target.value;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  //   const handleSelect = async (selectedOption, name) => {
  //     // Update formData with the selected value for the SkillID
  //     console.log("select----> ", selectedOption);
  //     setFormData((prevData) => {
  //       const updatedData = { ...prevData, [name]: selectedOption.value };
  //       // Trigger validation for the specific field after updating
  //       validateField(name, updatedData);
  //       return updatedData;
  //     });
  //   };
  const handleSelect = (selectedOption, name) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: selectedOption.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await PostServiceCaller(
        `${API_URL}rujul/object-type/${id}`,
        formData,
        "put"
      );

      if (response.status === 200) {
        toast.success("Data submitted successfully");
        //   setTimeout(() => {
        //       window.location.href = "/rujul/admin/general-master";
        //   }, 2000);
      } else {
        console.error(
          "Failed to submit data. Server responded with status:",
          response.status
        );
        console.error("Response data:", response.data);
      }
    } catch (error) {
      console.error("Unexpected Error:", error);
    }
    //    finally {
    //     setLoading(false);
    //   }
  };

  return (
    <div className="Container">
      {formData ? (
        <form onSubmit={handleSubmit} id="formOne" className="rounded mt-2 bg-white">
          <div className="row">
            <div className="col-md-12">
              {/* General Details */}
              <div class="card">
                <div class="card-header">
                  <h5 className="subheading">General Details</h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-2">
                      <div>
                        <label className="form-label">Code</label>
                        <input
                          type="text"
                          name="Code"
                          placeholder="Code"
                          className="form-control"
                          value={formData?.Code}
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div class="form-group">
                        <label className="form-label">
                          Name<span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          name="Name"
                          placeholder="Name"
                          className="form-control"
                          value={formData?.Name}
                          onChange={(e) => handleChange(e)}
                        />
                        {errors.Name && (
                          <div className="text-danger">{errors.Name}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div class="form-group">
                        <label className="form-label">Description</label>
                        <input
                          type="text"
                          name="Description"
                          placeholder="Description"
                          className="form-control"
                          value={formData?.Description}
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div class="form-group">
                        <label className="form-label">
                          Object Type Identifier
                        </label>
                        <input
                          type="text"
                          name="Name"
                          placeholder="Name"
                          className="form-control"
                          //   value={formData?.Name}
                          //   onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div class="mb-3">
                        <label for="Code" class="form-label">
                          Menu
                        </label>
                        <Select
                          value={menuList?.find(
                            (o) => o.value === formData?.Group_077
                          )}
                          options={menuList}
                          name="Group_077"
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div class="mb-3">
                        <label for="Code" class="form-label">
                          Heading
                        </label>
                        <Select
                          value={headingList?.find(
                            (o) => o.value === formData?.SubGroup_078
                          )}
                          options={headingList}
                          name="SubGroup_078"
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Additional Details */}
          <div className="row mt-2">
            <div className="col-md-12">
              <div class="card">
                <div class="card-header">
                  <h5 className="subheading">Additional Details</h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div class="col-md-2">
                      <div class="form-group">
                        <label className="form-label">Display Name</label>
                        <input
                          type="text"
                          name="DisplayName"
                          placeholder="Display Name"
                          className="form-control"
                          value={formData?.DisplayName}
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="Code" class="form-label">
                          Default Ledger Type
                        </label>
                        <Select
                          value={defaultLedger?.find(
                            (o) => o.value === formData?.DefaultLedgerType_002
                          )}
                          options={defaultLedger}
                          name="DefaultLedgerType_002"
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group">
                        <label className="form-label">Default Narration</label>
                        <input
                          type="text"
                          name="Name"
                          placeholder="Name"
                          className="form-control"
                          //   value={formData?.Name}
                          //   onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div class="mb-3">
                        <label for="Code" class="form-label">
                          Show In
                        </label>
                        <Select
                          value={showINList?.find(
                            (o) => o.value === formData?.ShowIn_102
                          )}
                          options={showINList}
                          name="ShowIn_102"
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group">
                        <label className="form-label">Menu Sequence</label>
                        <input
                          type="text"
                          name="MenuSequence"
                          placeholder="Menu Sequence"
                          className="form-control"
                          value={formData?.MenuSequence}
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group">
                        <label className="form-label">Validity Days</label>
                        <input
                          type="text"
                          name="ValidityDays"
                          placeholder="ValidityDays"
                          className="form-control"
                          value={formData?.ValidityDays}
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="CopyTaxesFromParent"
                        id="flexSwitchCheckChecked"
                        checked={formData.CopyTaxesFromParent === 1}
                        onChange={(e) => handleChange(e)}
                      />
                      <label className="form-label ms-2">Copy Taxes</label>
                    </div>
                    <div className="col-md-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="CheckPermissions"
                        id="flexSwitchCheckChecked"
                        checked={formData.CheckPermissions === 1}
                        onChange={(e) => handleChange(e)}
                      />
                      <label className="form-label ms-2">
                        Check Permission
                      </label>
                    </div>
                    <div className="col-md-3">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="CopyAccountsFromParent"
                        id="flexSwitchCheckChecked"
                        checked={formData.CopyAccountsFromParent === 1}
                        onChange={(e) => handleChange(e)}
                      />
                      <label className="form-label ms-2">
                        Copy Account From Parent
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-1 g-2">
            <div className="col-md-6">
              <div className="card">
                <div class="card-header">
                  <h5 className="subheading">Log Setting Details</h5>
                </div>
                <div className="card-body p-2">
                  <div className="row">
                    <div className="col-md-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="IsAdd"
                        id="flexSwitchCheckChecked"
                        checked={formData.IsAdd === 1}
                        onChange={(e) => handleChange(e)}
                      />
                      <label className="form-label ms-2">Add</label>
                    </div>
                    <div className="col-md-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="IsEdit"
                        id="flexSwitchCheckChecked"
                        checked={formData.IsEdit === 1}
                        onChange={(e) => handleChange(e)}
                      />
                      <label className="form-label ms-2">Edit</label>
                    </div>
                    <div className="col-md-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="IsDelete"
                        id="flexSwitchCheckChecked"
                        checked={formData.IsDelete === 1}
                        onChange={(e) => handleChange(e)}
                      />
                      <label className="form-label ms-2">Delete</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card">
                <div className="card-header">
                  <h5 className="subheading">Menu Setting Details</h5>
                </div>
                <div className="card-body p-2">
                  <div className="row">
                    <div className="col-md-4">
                      <div class="mb-3">
                        <label for="Code" class="form-label">
                          Plugin
                        </label>
                        <Select
                          value={plugINList?.find(
                            (o) => o.value === formData?.PluginName_081
                          )}
                          options={plugINList}
                          name="PluginName_081"
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div class="mb-3">
                        <label for="Code" class="form-label">
                          Controller
                        </label>
                        <Select
                          value={controllerList?.find(
                            (o) => o.value === formData?.ControllerName_082
                          )}
                          options={controllerList}
                          name="ControllerName_082"
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div class="mb-3">
                        <label for="Code" class="form-label">
                          Action
                        </label>
                        <Select
                          value={actionList?.find(
                            (o) => o.value === formData?.ActionName_083
                          )}
                          options={actionList}
                          name="ActionName_083"
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-1 g-2">
            <div className="col-md-6">
              <div className="card">
                <div class="card-header">
                  <h5 className="subheading">Round Off Details</h5>
                </div>
                <div className="card-body p-2">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="Code" class="form-label">
                          Round Off Level
                        </label>
                        <Select
                          value={round?.find(
                            (o) => o.value === formData?.RoundOffLevel_035
                          )}
                          options={round}
                          name="RoundOffLevel_035"
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label className="form-label">Round Off</label>
                        <input
                          type="text"
                          name="RoundOffValue"
                          placeholder="Round Off"
                          className="form-control"
                          value={formData?.RoundOffValue}
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div class="mb-3">
                        <label for="Code" class="form-label">
                          Account
                        </label>
                        <Select
                          value={accountList?.find(
                            (o) => o.value === formData?.RoundOffAccountID
                          )}
                          options={accountList}
                          name="RoundOffAccountID"
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card">
                <div class="card-header">
                  <h5 className="subheading">Default Account Setting</h5>
                </div>
                <div className="card-body p-2">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label for="Code" class="form-label">
                          Trade Disc. Account
                        </label>
                        <Select
                          value={accountList?.find(
                            (o) => o.value === formData?.TradeDiscountAccountID
                          )}
                          options={accountList}
                          name="TradeDiscountAccountID"
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label for="Code" class="form-label">
                          Trade Disc. Account After Tax
                        </label>
                        <Select
                          value={accountList?.find(
                            (o) =>
                              o.value ===
                              formData?.TradeDiscountAccountIDAfterTax
                          )}
                          options={accountList}
                          name="TradeDiscountAccountIDAfterTax"
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end mt-3">
            <div className="d-flex me-2">
              <div>
                <button
                  type="button"
                  className="cancel-btn me-2"
                  onClick={() =>
                    (window.location.href = "/rujul/admin/object-type")
                  }
                >
                  Cancel
                </button>
              </div>
              <div>
                <button type="submit" className="custom-btn">
                  {/* {loading ? <FaSpinner class="sm-spinner" /> : "Submit"} */}
                  Submit
                </button>
              </div>
            </div>
          </div>
        </form>
      ) : (
        <p>No data found</p>
      )}
    </div>
  );
};

export default ObjectTypeEdit;
